// Mock data for Cloverdale Insurance (modern redesign)
// NOTE: This data mirrors the original cloverdaleinsurance.ca content.
// Form submissions are mocked here until backend is wired up.

export const company = {
  name: "Cloverdale Insurance",
  legalName: "Cloverdale Insurance Services Ltd.",
  tagline: "Save Up To 60% • Free Quotes",
  phone: "+1 604-575-2222",
  phoneRaw: "16045752222",
  email: "info@cloverdaleinsurance.ca",
  altEmail: "cloverdaleinsurance@telus.net",
  address: "110, 17767 64 Ave, Surrey, BC V3S 1Z2, Canada",
  city: "Surrey, BC",
  hours: [
    { day: "Monday – Friday", time: "09:00 AM – 09:00 PM" },
    { day: "Saturday", time: "10:00 AM – 06:00 PM" },
    { day: "Sunday", time: "10:00 AM – 06:00 PM" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=17767+64+Ave,+Surrey,+BC+V3S+1Z2&output=embed",
};

export const navLinks = [
  { label: "Home", to: "/" },
  {
    label: "Car Insurance",
    to: "/car-insurance",
    children: [
      { label: "ICBC Autoplan Insurance", to: "/coverage/icbc-autoplan" },
      { label: "Commercial Fleet Insurance", to: "/coverage/fleet-insurance" },
      { label: "Prorate Insurance", to: "/coverage/prorate-insurance" },
      { label: "Garage Policy Insurance", to: "/coverage/garage-policy-insurance" },
      { label: "ICBC Policy Renewal", to: "/icbc-policy-renewal" },
    ],
  },
  {
    label: "Home Insurance",
    to: "/home-insurance",
    children: [
      { label: "High Value Home Insurance", to: "/coverage/high-value-home-insurance" },
      { label: "Rental Home Insurance", to: "/coverage/rental-home-insurance" },
      { label: "Condo Insurance", to: "/coverage/condo-insurance" },
      { label: "Construction Insurance", to: "/coverage/construction-insurance" },
      { label: "Boat Insurance", to: "/coverage/boat-insurance" },
    ],
  },
  {
    label: "Business Insurance",
    to: "/business-insurance",
    children: [
      { label: "Business Insurance", to: "/business-insurance" },
      { label: "Cargo Insurance", to: "/coverage/cargo-insurance" },
      { label: "Commercial Insurance", to: "/coverage/commercial-insurance" },
      { label: "Liability Insurance", to: "/coverage/liability-insurance" },
      { label: "Surety Bonds", to: "/coverage/surety-bonds" },
    ],
  },
  {
    label: "Travel Insurance",
    to: "/travel-insurance",
    children: [
      { label: "Travel Medical Insurance", to: "/coverage/travel-medical" },
      { label: "Student Medical Insurance", to: "/coverage/student-medical" },
      { label: "Super Visa Insurance", to: "/super-visa-insurance" },
      { label: "Visitor to Canada Insurance", to: "/coverage/visitor-to-canada" },
      { label: "Vacation Insurance", to: "/coverage/vacation-insurance" },
    ],
  },
  { label: "Super Visa Insurance", to: "/super-visa-insurance" },
  {
    label: "Contact Us",
    to: "/contact",
    children: [
      { label: "Contact Us", to: "/contact" },
      { label: "Claims", to: "/claims" },
      { label: "Forms", to: "/forms" },
    ],
  },
];

export const services = [
  {
    slug: "car-insurance",
    title: "Car Insurance",
    short: "ICBC Autoplan & more",
    hero: "Complete ICBC Autoplan Insurance Coverage",
    icon: "Car",
    image:
      "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxjYXIlMjByb2FkfGVufDB8fHx8MTc4NTQ1MTk4NHww&ixlib=rb-4.1.0&q=85",
    intro:
      "At Cloverdale Insurance Services Ltd., we have most of your auto insurance options covered. Offering monthly car insurance payment plans and free delivery service to surrounding areas of our office. Our staff will help you choose the best car insurance that suits your needs.",
    points: [
      "All types of ICBC Autoplan insurance",
      "Monthly car insurance payment plans available",
      "Free delivery service to surrounding areas",
      "Expert advice on optional coverages & extension policies",
    ],
    subServices: [
      {
        title: "ICBC Autoplan Insurance",
        desc: "Basic and optional ICBC Autoplan coverage tailored to your vehicle and driving needs.",
        to: "/coverage/icbc-autoplan",
      },
      {
        title: "Commercial Fleet Insurance",
        desc: "Cost-effective coverage for businesses operating multiple vehicles under one policy.",
        to: "/coverage/fleet-insurance",
      },
      {
        title: "Prorate Insurance",
        desc: "Interjurisdictional registration and insurance for commercial carriers operating across provinces and states.",
        to: "/coverage/prorate-insurance",
      },
      {
        title: "Garage Policy Insurance",
        desc: "Protects customers' vehicles in your care plus garage liability for dealerships, repair and autobody shops.",
        to: "/coverage/garage-policy-insurance",
      },
    ],
  },
  {
    slug: "home-insurance",
    title: "Home Insurance",
    short: "Protect your home & belongings",
    hero: "Protect Your Home With The Best Insurance Coverage",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lfGVufDB8fHx8MTc4NTQ1MTk4NHww&ixlib=rb-4.1.0&q=85",
    intro:
      "We can calculate the current rebuilding cost of your home using an industry accepted calculation method based on costs obtained from contractors. Protect what matters most with comprehensive home insurance coverage.",
    points: [
      "Accurate rebuilding cost calculation",
      "Homeowner, tenant & condo coverage options",
      "Protection against fire, theft, water damage & liability",
      "Bundle & save with auto and other policies",
    ],
    subServices: [
      {
        title: "High Value Home Insurance",
        desc: "Premium coverage with higher limits for luxury and high-value homes.",
        to: "/coverage/high-value-home-insurance",
      },
      {
        title: "Rental Home Insurance",
        desc: "Protection for landlords covering the building, liability and lost rental income.",
        to: "/coverage/rental-home-insurance",
      },
      {
        title: "Condo Insurance",
        desc: "Covers your unit improvements, contents, liability and strata deductible.",
        to: "/coverage/condo-insurance",
      },
      {
        title: "Construction Insurance",
        desc: "Course of construction and wrap-up liability for residential and commercial projects.",
        to: "/coverage/construction-insurance",
      },
      {
        title: "Boat Insurance",
        desc: "Coverage for your watercraft, liability, motors, trailers and personal effects.",
        to: "/coverage/boat-insurance",
      },
    ],
  },
  {
    slug: "business-insurance",
    title: "Business Insurance",
    short: "Commercial & liability coverage",
    hero: "Commercial Insurance Solutions For Your Business",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG9mZmljZXxlbnwwfHx8fDE3ODU0NTE5ODR8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "As an independent broker, Cloverdale Insurance can help you make informed decisions about your commercial insurance options. We specialize in different types of business and commercial insurance to keep your operations protected.",
    points: [
      "Commercial general liability (CGL)",
      "Commercial property & contents coverage",
      "Contractors & small business packages",
      "Independent broker — options from multiple insurers",
    ],
    subServices: [
      {
        title: "Cargo Insurance",
        desc: "Protect goods and freight in transit against loss or damage while being transported.",
        to: "/coverage/cargo-insurance",
      },
      {
        title: "Commercial Insurance",
        desc: "Protect your building, equipment, stock and business contents from unexpected loss.",
        to: "/coverage/commercial-insurance",
      },
      {
        title: "Liability Insurance",
        desc: "General and professional liability coverage that protects your business from claims.",
        to: "/coverage/liability-insurance",
      },
      {
        title: "Surety Bonds",
        desc: "Bonding solutions for contractors and businesses to guarantee performance and obligations.",
        to: "/coverage/surety-bonds",
      },
    ],
  },
  {
    slug: "travel-insurance",
    title: "Travel Insurance",
    short: "Vacation, family & business trips",
    hero: "Travel Insurance For Your Vacation, Family & Business Trips",
    icon: "Plane",
    image:
      "https://images.unsplash.com/photo-1539635278303-d4002c07eae3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHx0cmF2ZWwlMjB2YWNhdGlvbnxlbnwwfHx8fDE3ODU0NTE5ODR8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "With our affordable travel insurance packages, you can travel knowing you're protected against most unexpected travel situations — from medical emergencies to trip cancellations.",
    points: [
      "Emergency medical coverage abroad",
      "Trip cancellation & interruption protection",
      "Single trip & multi-trip annual plans",
      "Coverage for individuals, families & groups",
    ],
    subServices: [
      {
        title: "Travel Medical Insurance",
        desc: "Emergency medical protection for trips outside your home province or abroad.",
        to: "/coverage/travel-medical",
      },
      {
        title: "Student Medical Insurance",
        desc: "Health coverage for international students studying in Canada.",
        to: "/coverage/student-medical",
      },
      {
        title: "Super Visa Insurance",
        desc: "Compliant medical coverage for visiting parents and grandparents.",
        to: "/super-visa-insurance",
      },
      {
        title: "Visitor to Canada Insurance",
        desc: "Emergency medical coverage for visitors, new immigrants and returning Canadians.",
        to: "/coverage/visitor-to-canada",
      },
      {
        title: "Vacation Insurance",
        desc: "Trip cancellation, interruption and baggage protection for your getaway.",
        to: "/coverage/vacation-insurance",
      },
    ],
  },
  {
    slug: "super-visa-insurance",
    title: "Super Visa Insurance",
    short: "For parents & grandparents",
    hero: "Super Visa Insurance For Parents & Grandparents",
    icon: "Users",
    image:
      "https://images.unsplash.com/photo-1593100126453-19b562a800c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxncmFuZHBhcmVudHMlMjBmYW1pbHl8ZW58MHx8fHwxNzg1NDUxOTg0fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Super Visa Insurance services for parents and grandparents visiting Canada. Meet the Government of Canada requirements with a compliant medical insurance policy so your loved ones can stay longer with peace of mind.",
    points: [
      "Meets Government of Canada Super Visa requirements",
      "Minimum $100,000 emergency medical coverage",
      "Valid for at least one year from date of entry",
      "Monthly payment options available",
    ],
    subServices: [
      {
        title: "Compliant Coverage",
        desc: "Policies that fully meet IRCC Super Visa medical insurance requirements.",
      },
      {
        title: "Flexible Payments",
        desc: "Annual and monthly payment plans to fit your budget.",
      },
      {
        title: "Refund Options",
        desc: "Pro-rated refund options should visa plans change.",
      },
    ],
  },
];

export const stats = [
  { value: "60%", label: "Potential savings on premiums" },
  { value: "7", label: "Days a week we're open" },
  { value: "20+", label: "Years serving Surrey BC" },
  { value: "15+", label: "Trusted insurer partners" },
];

export const whyUs = [
  {
    icon: "ShieldCheck",
    title: "Independent Broker",
    desc: "We compare options from multiple top insurers to find you the best coverage and rate.",
  },
  {
    icon: "Wallet",
    title: "Monthly Payment Plans",
    desc: "Flexible monthly payment options so quality coverage stays affordable.",
  },
  {
    icon: "Clock",
    title: "Open 7 Days a Week",
    desc: "Extended weekday hours and weekend availability to serve you when you need us.",
  },
  {
    icon: "HeartHandshake",
    title: "Personalized Service",
    desc: "Local Surrey agents who take the time to understand your needs.",
  },
];

export const partnerLogos = [
  { name: "Renew ICBC Online", img: "/assets/partners/renew-icbc.png", link: "https://renew.icbc.com/" },
  { name: "ICBC Autoplan", img: "/assets/partners/icbc-autoplan.png", link: "https://www.icbc.com/insurance/Pages/Default.aspx" },
  { name: "Cansure", img: "/assets/partners/cansure.png", link: "https://cansure.com/" },
  { name: "Special Risk Insurance Managers", img: "/assets/partners/special-risk.png", link: "https://srim.ca/" },
  { name: "Agile Underwriting", img: "/assets/partners/agile.png", link: "https://agileuw.ca/" },
  { name: "Wawanesa Insurance", img: "/assets/partners/wawanesa.jpg", link: "https://www.wawanesa.com/" },
  { name: "Chutter Underwriting", img: "/assets/partners/chutter.png", link: "https://www.chutteruw.com/" },
  { name: "Optimum General", img: "/assets/partners/optimum.jpg", link: "https://www.optimum-general.com/" },
  { name: "Intact Insurance", img: "/assets/partners/intact.jpg", link: "https://www.intact.ca/bc/en/personal-insurance.html" },
  { name: "Forward Insurance", img: "/assets/partners/forward.png", link: "https://forwardinsurance.ca/" },
  { name: "PGUM Ltd.", img: "/assets/partners/pgum.png", link: "http://pgumltd.com/" },
  { name: "Reliance Glass", img: "/assets/partners/reliance-glass.png", link: "https://www.relianceglass.ca/" },
];

export const icbcRenewal = {
  portalUrl: "https://renew.icbc.com/",
  note: "Please Note: Policy Renewals, Policy Changes, Storage Policies and Temporary Operating Permits can be done by phone & email. ICBC has temporarily allowed these services by phone/email. Please call our office at 604-575-2222 or email us requesting the service required. To use this service you must have an email address to send us your consent and to receive your vehicle's insurance paperwork via email. No renewal is processed and no changes are made to your policy until we call you to discuss/confirm the request and confirm the changes/renewal over the phone, then send insurance documents via email to you. Requests are processed according to staff availability. For urgent requests, please call our office at 604-575-2222.",
  steps: [
    { title: "Start online", desc: "Click \"Renew ICBC Online\" to begin your renewal on ICBC's secure portal." },
    { title: "Call or email us", desc: "Contact our office at 604-575-2222 or by email to request your renewal or policy change." },
    { title: "Confirm & receive", desc: "We call you to confirm the details, then email your insurance documents to you." },
  ],
  locations: [
    "Cloverdale", "Surrey", "South Surrey", "Langley", "Delta", "Burnaby",
    "Coquitlam", "Port Coquitlam", "Port Moody", "New Westminster",
    "Richmond", "Vancouver", "Downtown Vancouver", "North Vancouver",
    "West Vancouver", "Maple Ridge", "Pitt Meadows", "Abbotsford", "Other",
  ],
  consentText:
    "Your privacy is very important to us. Cloverdale Insurance Services Ltd. wants to make sure your personal information stays safe and protected. This is your consent to communicate by email and to send/receive your personal information, insurance forms, and (if applicable) banking information by email. Please understand that receiving information by email may not always be secure — your email could be accessed and your information could be seen, shared, or changed without your permission, so we recommend deleting sensitive information from your email afterward. Depending on your email provider, information we send may be stored outside of Canada, and deleted messages may still exist in backups. After your transaction is processed, we will email you your policy documents; ICBC requires you to reply to that email to confirm whether you accept your policy terms.",
  agreementText:
    "I agree and understand that my insurance is NOT renewed and my coverage will NOT take effect until a licensed insurance representative has contacted me and confirmed that coverage is bound.",
  options: [
    {
      icon: "PhoneCall",
      title: "Request Your Renewal Now!",
      desc: "We make it easy and convenient to renew your ICBC insurance. Our Cloverdale auto agents will help you — just fill in your basic information below and we'll contact you directly.",
      cta: "Renew ICBC with Cloverdale Insurance",
      action: "form",
    },
    {
      icon: "Globe",
      title: "Renew on the ICBC Website",
      desc: "Protect yourself and your family with mandatory basic or extended coverage through ICBC. Complete your online renewal request directly with ICBC.",
      cta: "Renew auto insurance with ICBC",
      action: "portal",
    },
  ],
  faqs: [
    {
      q: "What is ICBC Online?",
      a: "ICBC Online lets eligible customers renew their policies over the internet. A policy is generally eligible if it's a personal policy due for renewal within 44 days, owned by a single individual who isn't making coverage changes, and covers a vehicle that isn't brand new.",
    },
    {
      q: "What policies cannot be renewed online?",
      a: "Online renewal isn't available for jointly owned, leased, company-owned, motorcycle, collector, expired, or commercial policies. Policies with an outstanding balance owing to ICBC, or that require changes to optional coverage at renewal, are also ineligible.",
    },
    {
      q: "How do I renew my policy online through ICBC?",
      a: "You securely log in using your BC Services Card app, confirm your coverage details without making changes, print your insurance documents, and have your chosen broker review the renewal after payment.",
    },
    {
      q: "What is the timeframe for online renewal?",
      a: "Online renewal becomes available 44 days before your policy expires. We recommend starting well before the expiry date to avoid any gap in coverage.",
    },
    {
      q: "How does ICBC verify my identity during online renewal?",
      a: "To be eligible, you verify your identity using the BC Services Card app. Additional verification options are being introduced by ICBC over time.",
    },
    {
      q: "Can I still use my Cloverdale broker to renew my auto insurance?",
      a: "Absolutely. You can renew through our online form above, over the phone, or in person. If you use ICBC Online, you can also select Cloverdale Insurance as your Broker of Choice and our team will reach out to review your transaction.",
    },
    {
      q: "How will I receive my ICBC documents?",
      a: "If you renew with us, we'll email your documents for printing, or mail you a hard copy on request. If you renew directly through ICBC, they'll email your documents for printing and can also mail a copy.",
    },
    {
      q: "What is the Low-Kilometre Discount?",
      a: "Infrequent drivers may qualify for a discount based on the distance driven over the last 12 months, calculated from odometer readings. It applies to annual policies only. Some rate classes (such as motorcycles and collector vehicles) aren't eligible because they already reflect low usage.",
    },
  ],
};

export const testimonials = [
  {
    name: "Harpreet S.",
    role: "Surrey, BC",
    quote:
      "Renewed my ICBC Autoplan in minutes. The team explained every coverage option clearly and saved me money.",
  },
  {
    name: "Jennifer M.",
    role: "Cloverdale, BC",
    quote:
      "Got home and auto bundled together. Friendly, fast, and open on weekends which is a lifesaver for me.",
  },
  {
    name: "Amandeep K.",
    role: "Langley, BC",
    quote:
      "Set up Super Visa insurance for my parents with zero hassle. Highly recommend Cloverdale Insurance.",
  },
];

export const insuranceTypes = [
  "Car Insurance (ICBC Autoplan)",
  "Home Insurance",
  "Business / Commercial Insurance",
  "Travel Insurance",
  "Super Visa Insurance",
  "Other",
];


export const claimsContacts = [
  {
    insurer: "ICBC",
    lines: [
      "Lower Mainland: 604-520-8222",
      "Elsewhere in B.C., Canada and the U.S.: 1-800-910-4222",
    ],
  },
  {
    insurer: "Destination Travel",
    lines: ["Toll Free: 1-855-337-3532"],
  },
  {
    insurer: "Intact",
    lines: ["Claims Hot Line (24/7): 1-866-464-2424"],
  },
  {
    insurer: "Wawanesa",
    lines: ["Claims Line (24/7): 1-844-929-2637"],
  },
  {
    insurer: "Optimum",
    lines: ["During non-business hours: 1-877-806-8023"],
  },
  {
    insurer: "Forward Insurance",
    lines: ["After Hours: 1-800-387-5677"],
  },
  {
    insurer: "Tugo Travel",
    lines: [
      "From Canada and USA: 1-800-663-0399",
      "From Mexico: 001-800-514-9976 / 800-681-8070",
      "Worldwide (collect): 604-278-4108",
    ],
  },
  {
    insurer: "Allianz",
    lines: [
      "Toll-free Canada/USA: 1-800-995-1662",
      "Toll-free worldwide: 00-800-842-08420",
      "or Country code + 800-842-08420",
    ],
  },
];

export const claimsNote =
  "Need to make a claim? Please call our office during business hours and we'll assist you. The numbers above are contact numbers for insurers during non-business & 24/7 hours. Please ensure you have your policy number available — this can be found on your travel card or policy declaration page.";

export const formsData = [
  {
    category: "Auto Insurance Forms",
    icon: "Car",
    forms: [
      {
        name: "Bill Of Sale",
        url: "http://www.cloverdaleinsurance.ca/wp-content/uploads/2019/08/ICBC-Bill-of-Sale.pdf",
      },
      {
        name: "Temporary Operating Permit Authorization Letter",
        url: "http://www.cloverdaleinsurance.ca/wp-content/uploads/2019/08/auto-temporary-operating-permit-authorization-letter.pdf",
      },
    ],
  },
  {
    category: "Home Insurance Forms",
    icon: "Home",
    forms: [
      {
        name: "Policy Cancellation Request",
        url: "http://www.cloverdaleinsurance.ca/wp-content/uploads/2019/12/Cancellation-Form-2019.pdf",
      },
      {
        name: "Release of Interest Request",
        url: "http://www.cloverdaleinsurance.ca/wp-content/uploads/2019/08/pl-release-of-interest.pdf",
      },
      {
        name: "Privacy Disclosure & Consent",
        url: "http://www.cloverdaleinsurance.ca/wp-content/uploads/2019/08/pl-privacy-disclosure-and-consent.pdf",
      },
    ],
  },
  {
    category: "Commercial Forms",
    icon: "Building2",
    forms: [
      {
        name: "National Safety Code Authorization",
        url: "http://www.cloverdaleinsurance.ca/wp-content/uploads/2019/08/globalins-forms-national-safety-code-auth.pdf",
      },
    ],
  },
];

// Sub-product pages — original descriptions based on Cloverdale's product line
export const subPages = {
  "garage-policy-insurance": {
    parentSlug: "car-insurance",
    parentTitle: "Car Insurance",
    title: "Garage Policy Insurance",
    hero: "Auto Garage & Garage Liability Insurance — Surrey BC",
    icon: "Wrench",
    image:
      "https://images.unsplash.com/photo-1767681092416-bccf9410bda4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxhdXRvJTIwcmVwYWlyJTIwZ2FyYWdlfGVufDB8fHx8MTc5MDE5MTU2N3ww&ixlib=rb-4.1.0&q=85",
    intro:
      "Are you in the business of repairing, servicing, storing/parking or selling customers' vehicles? Then you need a garage policy. Car dealerships, glass repair and auto detail shops, auto repair garages and autobody shops all need this coverage to protect customers' vehicles while they're in their care. A garage policy provides property coverage for customers' vehicles and liability coverage for operating them (such as test drives), and can also cover a dealership's vehicle inventory. Our staff will be happy to help you set up your garage policy and answer any questions.",
    points: [
      "Property coverage for customers' vehicles in your care",
      "Garage liability for operating customer vehicles (e.g. test drives)",
      "Coverage for dealership vehicle inventory",
      "Protection from fire, theft, vandalism, explosion & lightning",
      "Ideal for dealerships, repair, autobody & detail shops",
      "Setup guidance from our commercial specialists",
    ],
  },
  "high-value-home-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "High Value Home Insurance",
    hero: "Premium Protection For High Value Homes",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1585544314038-a0d3769d0193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob21lfGVufDB8fHxibHVlfDE3OTAxOTEwODR8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Luxury and high-value homes deserve specialized coverage. We tailor policies with higher limits and enhanced features so your distinctive home, fine finishes and valuable contents are fully protected. Eligible clients can also access discounts and convenient monthly payment options.",
    points: [
      "Higher coverage limits & guaranteed replacement options",
      "Protection for fine art, jewellery & collectibles",
      "Enhanced water damage & liability coverage",
      "Cash settlement options on total loss",
      "Discounts for alarms, claims-free & newer homes",
      "Personalized service from local agents",
    ],
  },
  "rental-home-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "Rental Home Insurance",
    hero: "Coverage For Landlords & Rental Properties",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1519227355453-8f982e425321?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxyZW50YWwlMjBwcm9wZXJ0eXxlbnwwfHx8Ymx1ZXwxNzkwMTkxMDg0fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "If you own a property you rent out, a standard homeowner policy won't be enough. Rental home insurance protects your building, your liability as a landlord, and the rental income you rely on. We'll tailor coverage to your property and tenants.",
    points: [
      "Building & landlord's contents coverage",
      "Loss of rental income protection",
      "Landlord liability coverage",
      "Protection from fire, theft & water damage",
      "Coverage for single or multiple units",
      "Flexible monthly payment options",
    ],
  },
  "condo-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "Condo Insurance",
    hero: "Protect Your Condo & What's Inside",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1588835743485-5845e40364fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxjb25kbyUyMGJ1aWxkaW5nfGVufDB8fHx8MTc5MDE5MTA4NHww&ixlib=rb-4.1.0&q=85",
    intro:
      "Your strata corporation's policy usually covers the building, but not your unit improvements, contents or personal liability. Condo insurance fills those gaps — including protection for your strata deductible and loss assessments.",
    points: [
      "Unit upgrades & improvements coverage",
      "Personal belongings & contents",
      "Personal liability protection",
      "Strata deductible & loss assessment coverage",
      "Additional living expenses if displaced",
      "Affordable, tailored packages",
    ],
  },
  "boat-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "Boat Insurance",
    hero: "Enjoy The Water With Confidence",
    icon: "Ship",
    image:
      "https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxib2F0JTIweWFjaHR8ZW58MHx8fHwxNzkwMTkxMDg0fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Whether you own a runabout, sailboat or yacht, boat insurance protects your watercraft, passengers and personal effects. We'll help you find coverage that lets you enjoy the water with peace of mind.",
    points: [
      "Physical damage to your watercraft",
      "Watercraft liability coverage",
      "Coverage for motors, trailers & equipment",
      "Personal effects & emergency towing",
      "Options for a range of vessel types",
      "Guidance from our friendly agents",
    ],
  },
  "travel-medical": {
    parentSlug: "travel-insurance",
    parentTitle: "Travel Insurance",
    title: "Travel Medical Insurance",
    hero: "Emergency Medical Coverage While You Travel",
    icon: "Stethoscope",
    image:
      "https://images.pexels.com/photos/8383889/pexels-photo-8383889.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Most provincial health plans only cover expenses within your home province. Travel medical insurance protects you against unexpected emergency medical costs when you travel — anywhere in Canada or abroad — so you can travel with confidence.",
    points: [
      "Emergency medical & hospital coverage",
      "Coverage outside your home province & abroad",
      "Single trip & annual multi-trip plans",
      "Emergency transportation & assistance",
      "Plans for individuals, families & groups",
      "Advice on the right level of coverage",
    ],
  },
  "student-medical": {
    parentSlug: "travel-insurance",
    parentTitle: "Travel Insurance",
    title: "Student Medical Insurance",
    hero: "Health Coverage For International Students",
    icon: "GraduationCap",
    image:
      "https://images.pexels.com/photos/6147143/pexels-photo-6147143.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "International students studying in Canada may not be covered by a provincial health plan right away. Student medical insurance provides the emergency medical protection you need while you focus on your studies.",
    points: [
      "Emergency medical coverage for students",
      "Coverage while waiting for provincial health",
      "Doctor visits, hospital & prescriptions",
      "Affordable plans designed for students",
      "Flexible terms to match your studies",
      "Friendly help choosing your plan",
    ],
  },
  "visitor-to-canada": {
    parentSlug: "travel-insurance",
    parentTitle: "Travel Insurance",
    title: "Visitor to Canada Insurance",
    hero: "Medical Protection For Visitors to Canada",
    icon: "PlaneLanding",
    image:
      "https://images.unsplash.com/photo-1532968899863-5b52ef155913?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxhaXJwb3J0JTIwYXJyaXZhbHxlbnwwfHx8fDE3OTAxOTEwODR8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Medical and dental care can be expensive in Canada, and visitors are often not covered by any local plan. Visitor to Canada insurance provides emergency medical coverage for visiting family, friends, new immigrants and returning Canadians.",
    points: [
      "Emergency medical coverage in Canada",
      "Coverage for visitors, new immigrants & returnees",
      "Options with or without pre-existing conditions",
      "Flexible coverage amounts & durations",
      "Fast setup — ideal for arriving guests",
      "Monthly payment options available",
    ],
  },
  "vacation-insurance": {
    parentSlug: "travel-insurance",
    parentTitle: "Travel Insurance",
    title: "Vacation Insurance",
    hero: "Travel & Vacation With Peace Of Mind",
    icon: "Palmtree",
    image:
      "https://images.unsplash.com/photo-1550399504-8953e1a6ac87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxiZWFjaCUyMHZhY2F0aW9ufGVufDB8fHx8MTc5MDE5MTA4NHww&ixlib=rb-4.1.0&q=85",
    intro:
      "Protect your well-earned getaway. Vacation insurance can cover trip cancellation and interruption, lost or delayed baggage, and emergency medical costs — so an unexpected event doesn't ruin your trip or your budget.",
    points: [
      "Trip cancellation & interruption coverage",
      "Lost, stolen or delayed baggage protection",
      "Emergency medical while on vacation",
      "Single trip & annual multi-trip plans",
      "Coverage for families & groups",
      "Wide range of benefits to choose from",
    ],
  },

  "icbc-autoplan": {
    parentSlug: "car-insurance",
    parentTitle: "Car Insurance",
    title: "ICBC Autoplan Insurance",
    hero: "Surrey Auto Insurance | ICBC Autoplan Made Easy",
    icon: "Car",
    image:
      "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxjYXIlMjByb2FkfGVufDB8fHx8MTc4NTQ1MTk4NHww&ixlib=rb-4.1.0&q=85",
    intro:
      "At Cloverdale Insurance Services Ltd. we have most of your car insurance options covered. We offer monthly Autoplan payment plans and free delivery service to Surrey and the surrounding areas. Our friendly staff will help you choose the ICBC Autoplan coverage that best suits your needs and budget.",
    points: [
      "Basic and optional ICBC Autoplan coverage",
      "Extended third-party liability & collision options",
      "Monthly payment plans available",
      "Free delivery service to Surrey & surrounding areas",
      "Storage policies, temporary permits & transfers",
      "Expert advice from local Autoplan specialists",
    ],
  },
  "fleet-insurance": {
    parentSlug: "car-insurance",
    parentTitle: "Car Insurance",
    title: "Commercial Fleet Insurance",
    hero: "Commercial Auto & Fleet Insurance — Surrey BC",
    icon: "Truck",
    image:
      "https://images.pexels.com/photos/27099094/pexels-photo-27099094.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Do you have a fleet of trucks or vehicles to insure for your business? Cloverdale Insurance Services Ltd. manages fleet insurance for many leading trucking, construction, electrical, limousine, contractor and school operators across the Lower Mainland. Our experience is well suited to the demands of fleet insurance in these industries — helping you organize the right coverage while saving time and money.",
    points: [
      "Single policy covering multiple vehicles",
      "Tailored coverage for trucking, contractors & more",
      "Simplified administration and renewals",
      "Cost savings vs. insuring vehicles individually",
      "Support for schools, limousines & delivery fleets",
      "Guidance from experienced fleet specialists",
    ],
  },
  "prorate-insurance": {
    parentSlug: "car-insurance",
    parentTitle: "Car Insurance",
    title: "Prorate Insurance",
    hero: "Commercial Prorate & Truck Insurance — Surrey BC",
    icon: "Truck",
    image:
      "https://images.unsplash.com/photo-1695222833131-54ee679ae8e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxoaWdod2F5JTIwdHJ1Y2t8ZW58MHx8fHwxNzkwMTg0NDY4fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "If your fleet regularly travels out of province, you generally need specialized prorate insurance. Prorate coverage involves specialized licensing and registration, so when your vehicles enter a jurisdiction outside British Columbia your organization is exempt from having to purchase individual trip permits. Let us help you set up your prorate insurance — we're happy to answer your questions and guide you through the process.",
    points: [
      "Interjurisdictional registration & licensing",
      "Avoid buying individual trip permits",
      "Coverage for carriers travelling across provinces & states",
      "Specialist help with IRP setup and paperwork",
      "Ideal for long-haul and cross-border operators",
      "Personal guidance from our commercial team",
    ],
  },
  "homeowner-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "Homeowner Insurance",
    hero: "Protect Your Home With The Right Coverage",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lfGVufDB8fHx8MTc4NTQ1MTk4NHww&ixlib=rb-4.1.0&q=85",
    intro:
      "Your home is one of your biggest investments. We can calculate the current rebuilding cost of your home using an industry-accepted method based on costs obtained from contractors, then match you with comprehensive coverage that protects your house, belongings and family.",
    points: [
      "Accurate rebuilding cost calculation",
      "Dwelling, contents & detached structures",
      "Protection from fire, theft & water damage",
      "Personal liability coverage",
      "Optional add-ons for valuables & overland water",
      "Bundle & save with your auto insurance",
    ],
  },
  "tenant-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "Tenant / Renter Insurance",
    hero: "Affordable Protection For Renters",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1628592102751-ba83b0314276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTAxODQ0NjF8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Even if you rent, your landlord's policy won't cover your belongings or personal liability. Tenant insurance is an affordable way to protect your possessions and give you peace of mind whether you're renting an apartment, condo or house.",
    points: [
      "Coverage for your personal belongings",
      "Personal liability protection",
      "Additional living expenses if you're displaced",
      "Protection against fire, theft & water damage",
      "Affordable monthly options",
      "Fast, easy setup with a local agent",
    ],
  },
  "construction-insurance": {
    parentSlug: "home-insurance",
    parentTitle: "Home Insurance",
    title: "Construction Insurance",
    hero: "Course of Construction Insurance For Your Projects",
    icon: "HardHat",
    image:
      "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Whether you're in the planning stage, actively building or nearing completion, we can protect your professional construction project. Coverage features include Contractor's Commercial General Liability, Project Owner's Commercial General Liability, Builder's Risk / Course of Construction and Comprehensive Home Builder's Risk coverage.",
    points: [
      "Contractor's Commercial General Liability",
      "Project Owner's Commercial General Liability",
      "Builder's Risk / Course of Construction",
      "Comprehensive Home Builder's Risk coverage",
      "Coverage for residential & commercial projects",
      "Support from planning through completion",
    ],
  },
  "cargo-insurance": {
    parentSlug: "business-insurance",
    parentTitle: "Business Insurance",
    title: "Cargo Insurance",
    hero: "Protect Your Goods In Transit",
    icon: "PackageCheck",
    image:
      "https://images.pexels.com/photos/10834810/pexels-photo-10834810.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Cargo insurance protects the goods and freight you transport against loss or damage while in transit. Whether you're a carrier, freight forwarder or business shipping products, we can arrange coverage that keeps your shipments — and your bottom line — protected.",
    points: [
      "Coverage for goods & freight in transit",
      "Protection against theft, damage & loss",
      "Options for carriers & freight forwarders",
      "Coverage on the road, and where required, beyond",
      "Flexible limits to match your shipments",
      "Advice from our commercial insurance team",
    ],
  },
  "commercial-insurance": {
    parentSlug: "business-insurance",
    parentTitle: "Business Insurance",
    title: "Commercial Insurance",
    hero: "Commercial Insurance Solutions For Your Business",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzkwMTg0NDY4fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Cloverdale Insurance Services specializes in all varieties of business and commercial insurance at reasonable rates. We help protect you against loss of business due to fire, damage to your premises or key equipment, and other unpreventable events so you can focus on running your operation.",
    points: [
      "Commercial property & contents coverage",
      "Business interruption protection",
      "Coverage for equipment & stock",
      "Tailored packages for your industry",
      "Independent broker — options from many insurers",
      "Reasonable rates and personal service",
    ],
  },
  "liability-insurance": {
    parentSlug: "business-insurance",
    parentTitle: "Business Insurance",
    title: "Liability Insurance",
    hero: "Liability Coverage That Protects Your Business",
    icon: "ShieldCheck",
    image:
      "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3OTAxODQ0NjF8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Liability insurance protects your business from the financial impact of claims for bodily injury or property damage. From commercial general liability to professional liability, we'll help you find the right protection so an unexpected claim doesn't put your business at risk.",
    points: [
      "Commercial General Liability (CGL)",
      "Professional liability options",
      "Protection against bodily injury claims",
      "Property damage claim coverage",
      "Coverage tailored to your operations",
      "Guidance from experienced brokers",
    ],
  },
  "surety-bonds": {
    parentSlug: "business-insurance",
    parentTitle: "Business Insurance",
    title: "Surety Bonds",
    hero: "Surety Bonds For Contractors & Businesses",
    icon: "FileSignature",
    image:
      "https://images.unsplash.com/photo-1521791055366-0d553872125f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjb250cmFjdCUyMHNpZ25pbmd8ZW58MHx8fHwxNzkwMTg0NDY4fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Surety bonds guarantee that obligations will be met — commonly required for contractors bidding on and completing projects. We can arrange the bonding solutions your business needs to win work and demonstrate financial reliability to clients and project owners.",
    points: [
      "Bid, performance & payment bonds",
      "Bonding for contractors & trades",
      "Guarantee of contractual obligations",
      "Support for public & private projects",
      "Fast turnaround with our surety partners",
      "Personal help through the application",
    ],
  },
};

